function Link_form_element(element) {
    this.$element = $(element);
    this.popup = i4_Popup.get(this.$element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    radioMaster: '.js-radio-master',
	    fieldExtern: '.js-field-extern',
	    fieldAnchor: '.js-field-anchor',
	    selectIntern: '.js-select-intern',
	    fieldTitle: '.js-field-title',
	    containerExtern: '.js-container-extern',
	    containerAnchor: '.js-container-anchor',
	    containerIntern: '.js-container-intern'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded',
	    updateView: 'i4:updateView',
      validate: 'i4:validate',
      refresh: 'i4:refresh'
    };

    this.classNames = {
	    disabled: 'disabled'
    };

    this.init = function() {
	    this.$formParent = this.$element.closest(this.selectors.formParent);
	    this.$radioMaster = this.$element.find(this.selectors.radioMaster);
	    this.$fieldExtern = this.$element.find(this.selectors.fieldExtern);
	    this.$fieldAnchor = this.$element.find(this.selectors.fieldAnchor);
	    this.$selectIntern = this.$element.find(this.selectors.selectIntern);
	    this.$fieldTitle = this.$element.find(this.selectors.fieldTitle);
	    this.$containerExtern = this.$element.find(this.selectors.containerExtern);
	    this.$containerAnchor = this.$element.find(this.selectors.containerAnchor);
	    this.$containerIntern = this.$element.find(this.selectors.containerIntern);

	    this.$radioMaster.on('i4:change', this.$onChangeRadio.bind(this));
	    this.$fieldExtern.on('i4:change', this.$onChangeLink.bind(this));
	    this.$fieldAnchor.on('i4:change', this.$onChangeLink.bind(this));
	    this.$selectIntern.on('i4:change', this.$onChangeLink.bind(this));

      this.$formParent.on(this.triggers.afterLoaded, (function() {
        this.updateView();
      }).bind(this));
    };

    this.$onChangeRadio = function(event) {
	    event.preventDefault();

		  this.updateView();
		  this.renewValidator();
    };

    this.$onChangeLink = function(event) {
	    this.renewValidator();
    };

    this.renewValidator = function() {
      if (
        (this.currentType === 'external' && this.$fieldExtern.val() != '') ||
        (this.currentType === 'internal' && this.$selectIntern.val() != '') ||
        (this.currentType === 'anchor' && this.$fieldAnchor.val() != '')
      ) {
        	this.$fieldTitle.attr('data-required', 1);
	    } else {
		    this.$fieldTitle.attr('data-required', 0);
	    }

      this.$formParent.trigger(this.triggers.validate);
    };

    this.updateView = function() {
	    if (this.$radioMaster.find('input[type=radio]').first().is(':checked')) {

		    this.currentType = 'external';
		    this.$containerExtern.show();
		    this.$containerIntern.hide();
        this.$containerAnchor.hide();
		    this.$fieldExtern.toggleClass(this.classNames.disabled, false);
		    this.$selectIntern.toggleClass(this.classNames.disabled, true);
        this.$fieldAnchor.toggleClass(this.classNames.disabled, true);

	    } else if(this.$radioMaster.find('input[type=radio][value=2]').is(':checked')) {

        this.currentType = 'anchor';
        this.$containerExtern.hide();
        this.$containerIntern.hide();
        this.$containerAnchor.show();
        this.$fieldExtern.toggleClass(this.classNames.disabled, true);
        this.$selectIntern.toggleClass(this.classNames.disabled, true);
        this.$fieldAnchor.toggleClass(this.classNames.disabled, false);

      } else {

		    this.currentType = 'internal';
		    this.$containerExtern.hide();
		    this.$containerIntern.show();
        this.$containerAnchor.hide();
			  this.$fieldExtern.toggleClass(this.classNames.disabled, true);
		    this.$selectIntern.toggleClass(this.classNames.disabled, false);
        this.$fieldAnchor.toggleClass(this.classNames.disabled, true);
      }
      this.$formParent.trigger(this.triggers.refresh);
    };
}
